import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';

import APACSectionStyle from './style';

import Logo from 'src/components/atoms/logo';

const APACSection = () => {
  const { t } = useTranslation('business');

  return (
    <APACSectionStyle>
      <span role="img" aria-label={t('fastest_grow_in_apac_alt')} />
      <Logo />
      <Typography className="title">{t('fastest_grow_in_apac')}</Typography>
      <Typography className="subtitle">{t('ranking_from_financial_times')}</Typography>
    </APACSectionStyle>
  );
};

export default APACSection;
